/**
 * Check that value is defined
 *
 * @param array - value to check
 */
export function filterNotDefinedItems<T>(
  array: T[],
): (T extends null | undefined ? never : T)[] {
  return array.filter(
    (value): value is Exclude<T, null | undefined> =>
      value !== null && value !== undefined,
  );
}
